import { useQuery } from 'react-query';
import request from '../helpers/request';

const getRequestStreets = async () => {
  const res = await request.get(
    '/Request/streets',
    {},
    'Не удалось загрузить улицы',
    []
  );
  return res;
};

const useRequestStreets = (options) =>
  useQuery('streets', getRequestStreets, options);

export default useRequestStreets;
